import { render, staticRenderFns } from "./Cupones.vue?vue&type=template&id=9dde7230"
import script from "./Cupones.vue?vue&type=script&lang=js"
export * from "./Cupones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dde7230')) {
      api.createRecord('9dde7230', component.options)
    } else {
      api.reload('9dde7230', component.options)
    }
    module.hot.accept("./Cupones.vue?vue&type=template&id=9dde7230", function () {
      api.rerender('9dde7230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/settings/Cupones.vue"
export default component.exports